<template>
  <div class="batch-pay-fee-order-container">
    <el-row :gutter="20">
      <el-col :span="4">
        <el-card class="payer-object-card">
          <div class="card-title">收费对象</div>
          <div class="checkbox-list">
            <el-checkbox-group v-model="batchPayFeeOrderInfo.payerObjNames" @change="_chanagePayerObjName">
              <el-checkbox v-for="(item, index) in batchPayFeeOrderInfo.payObjs" :key="index" :label="item"
                class="checkbox-item">{{ item }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-card>
      </el-col>
      <el-col :span="20">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>{{ $t('batchPayFeeOrder.title') }}</span>
            <el-button type="primary" size="small" class="float-right" @click="_goBack">{{ $t('common.back')
            }}</el-button>
          </div>

          <el-table :data="batchPayFeeOrderInfo.batchFees" border style="width: 100%" v-loading="loading"
            @selection-change="handleSelectionChange" ref="batchFeeTable">
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column prop="feeTypeCdName" :label="$t('batchPayFeeOrder.feeType')"
              align="center"></el-table-column>
            <el-table-column prop="feeName" :label="$t('batchPayFeeOrder.feeItem')" align="center"></el-table-column>
            <el-table-column prop="feeFlagName" :label="$t('batchPayFeeOrder.feeFlag')"
              align="center"></el-table-column>
            <el-table-column :label="$t('batchPayFeeOrder.payerObj')" align="center">
              <template slot-scope="scope">
                {{ _getBatchPayFeeRoomName(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column prop="builtUpArea" :label="$t('batchPayFeeOrder.area')" align="center" width="100">
              <template slot-scope="scope">
                {{ scope.row.builtUpArea || '-' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('batchPayFeeOrder.oweDays')" align="center" width="120">
              <template slot-scope="scope">
                {{ _calculateOweDuration(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('batchPayFeeOrder.receivablePeriod')" align="center" width="180">
              <template slot-scope="scope">
                <div>{{ _getEndTime(scope.row) }}</div>
                <div>{{ _getDeadlineTime(scope.row) }}</div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('batchPayFeeOrder.receivable')" align="center">
              <template slot-scope="scope">
                {{ scope.row.receivableAmount }}/{{ scope.row.amountOwed }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('batchPayFeeOrder.paymentCycle')" align="center" width="150">
              <template slot-scope="scope">
                <div v-if="scope.row.feeFlag != '2006012'">
                  <div v-if="scope.row.tempCycle == '-102'" class="cycle-text">周期：{{ scope.row.cycles }}个月</div>
                  <div v-else-if="scope.row.tempCycle == '-101'" class="custom-amount">
                    自定义金额<br>{{ scope.row.receivedAmount }}</div>
                  <div v-else-if="scope.row.tempCycle == '-103'" class="custom-end-time">
                    结束时间<br>{{ scope.row.custEndTime }}</div>
                  <el-select v-else v-model="scope.row.cycles" @change="_changeMonth(scope.row.cycles, scope.row)"
                    style="width:100%">
                    <el-option v-for="item in _getBatchPaymentCycles(scope.row)" :key="item"
                      :label="`${item}${$t('batchPayFeeOrder.month')}`" :value="item"></el-option>
                  </el-select>
                  <el-button type="text" icon="el-icon-setting" @click="_settingsFeeCycle(scope.row)"></el-button>
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column :label="$t('batchPayFeeOrder.actualAmount')" align="center" width="150">
              <template slot-scope="scope">
                <el-input v-if="scope.row.receivedAmountSwitch == '1'" v-model="scope.row.receivedAmount"
                  :placeholder="$t('batchPayFeeOrder.enterActualAmount')" @change="_doComputeTotalFee"></el-input>
                <span v-else>{{ scope.row.receivedAmount }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('batchPayFeeOrder.remark')" align="center" width="200">
              <template slot-scope="scope">
                <el-input v-model="scope.row.remark" :placeholder="$t('batchPayFeeOrder.enterRemark')"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <div class="margin-top">
          <pay-fee-user-account ref="payFeeUserAccount"
            @changeUserAmountPrice="changeUserAmountPrice"></pay-fee-user-account>
        </div>
        <pay-fee-deposit ref="payFeeDeposit"></pay-fee-deposit>

        <el-row class="footer-row text-left" style="align-items: center;">
          <el-col :span="14">
            <div class="tips">
              <p>温馨提示：批量缴费不支持优惠折扣和优惠券抵扣功能，如需要请到缴费页面缴费</p>
              <p><b>缴费金额：缴费金额等于所有实收</b></p>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="total-amount">
              缴费金额：<span class="amount">{{ batchPayFeeOrderInfo.feePrices }}元</span>
            </div>
          </el-col>
          <el-col :span="3" style="padding-right: 5px;">
            <el-button type="success" size="medium" style="width: 100%;" @click="_openPayFee('qrCode')">{{ $t('batchPayFeeOrder.scanPay')
            }}</el-button>
          </el-col>
          <el-col :span="3" style="padding-left: 5px;">
            <el-button type="primary" size="medium" style="width: 100%;" @click="_openPayFee('common')">手工收费</el-button>
          </el-col>
        </el-row>

      </el-col>
    </el-row>

    <batch-pay-confirm ref="batchPayConfirm"></batch-pay-confirm>
    <batch-fee-cycle ref="batchFeeCycle" @changeMonth="batchChangeMonth"></batch-fee-cycle>
  </div>
</template>

<script>
import { getCommunityId, getDict } from '@/api/community/communityApi'
import PayFeeUserAccount from '@/components/fee/payFeeUserAccount'
import PayFeeDeposit from '@/components/fee/payFeeDeposit'
import BatchPayConfirm from '@/components/fee/batchPayConfirm'
import BatchFeeCycle from '@/components/fee/batchFeeCycle'
import { listFee, listFeeObj } from '@/api/fee/batchPayFeeOrderApi'
import { comprehensiveQuery } from '@/api/simplify/simplifyAcceptanceApi'
import { dateFormat, dateAdd } from '@/utils/dateUtil'

export default {
  name: 'BatchPayFeeOrderList',
  components: {
    PayFeeUserAccount,
    PayFeeDeposit,
    BatchPayConfirm,
    BatchFeeCycle
  },
  data() {
    return {
      loading: false,
      batchPayFeeOrderInfo: {
        batchFees: [],
        allBatchFees: [],
        selectPayFeeIds: [],
        feePrices: 0.00,
        communityId: '',
        ownerId: '',
        payerObjType: '',
        remark: '',
        payerObjNames: [],
        payObjs: [],
        accountAmount: 0.0,
        acctId: '',
        primeRates: [],
        primeRate: 'aggregate', // 默认选中聚合支付
        offlinePayFeeSwitch: '1'
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this._initData()
    this.getDictData()
  },
  methods: {
    // 新增：处理表格选择变化
    handleSelectionChange(selection) {
      console.log('选中的行:', selection)

      // 更新 selectPayFeeIds 数组
      this.batchPayFeeOrderInfo.selectPayFeeIds = selection.map(item => item.feeId)

      console.log('更新后的 selectPayFeeIds:', this.batchPayFeeOrderInfo.selectPayFeeIds)

      // 重新计算总费用
      this._doComputeTotalFee()
    },

    // 新增：设置表格选中状态
    setTableSelection() {
      // 根据 selectPayFeeIds 设置表格的选中状态
      this.$nextTick(() => {
        if (this.$refs.batchFeeTable) {
          this.batchPayFeeOrderInfo.batchFees.forEach(row => {
            if (this.batchPayFeeOrderInfo.selectPayFeeIds.includes(row.feeId)) {
              this.$refs.batchFeeTable.toggleRowSelection(row, true)
            }
          })
        }
      })
    },

    async _initData() {
      const ownerId = this.$route.query.ownerId
      const payerObjType = this.$route.query.payerObjType

      if (!ownerId) {
        this.$message.error('非法操作')
        this.$router.go(-1)
        return
      }

      this.batchPayFeeOrderInfo.ownerId = ownerId
      this.batchPayFeeOrderInfo.payerObjType = payerObjType

      await this._loadBatchFees()

      setTimeout(() => {
        this.$refs.payFeeUserAccount.open({ ownerId: this.batchPayFeeOrderInfo.ownerId })
        this.$refs.payFeeDeposit.open({ payerObjId: this.batchPayFeeOrderInfo.ownerId, payerObjType: this.batchPayFeeOrderInfo.payerObjType })
      }, 1000)
    },

    async getDictData() {
      try {
        const data = await getDict('pay_fee_detail', 'prime_rate')
        this.batchPayFeeOrderInfo.primeRates = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },

    async _loadBatchFees() {
      this.loading = true
      try {
        const params = {
          page: 1,
          row: 500,
          communityId: this.communityId,
          ownerId: this.batchPayFeeOrderInfo.ownerId,
          payerObjType: this.batchPayFeeOrderInfo.payerObjType,
          state: '2008001'
        }

        const res = await listFee(params)

        let _batchFees = []
        let _selectPayFeeIds = []

        // 获取业主的房间信息，用于补充 builtUpArea 和 oweDay
        let roomInfoMap = {}
        try {
          const ownerRes = await comprehensiveQuery({
            searchType: '11', // 按业主ID查询
            searchValue: this.batchPayFeeOrderInfo.ownerId,
            communityId: this.communityId
          })
          
          if (ownerRes.data && ownerRes.data.rooms) {
            // 建立 roomId -> roomInfo 的映射
            ownerRes.data.rooms.forEach(room => {
              roomInfoMap[room.roomId] = room
            })
          }
        } catch (error) {
          console.error('获取房间信息失败:', error)
        }

        res.fees.sort(this._batchRoomFeeCompare).forEach(feeItem => {
          // 从房间信息中获取 builtUpArea
          const roomInfo = roomInfoMap[feeItem.payerObjId]
          const builtUpArea = roomInfo ? roomInfo.builtUpArea : null
          
          _batchFees.push({
            ...feeItem,
            cycles: feeItem.paymentCycle,
            receivableAmount: feeItem.feeTotalPrice,
            receivedAmount: feeItem.feeTotalPrice,
            tempCycle: '-100',
            builtUpArea: builtUpArea, // 添加房屋面积
            oweDay: feeItem.oweDay || 0 // 欠费时长，如果后端没有返回则默认为0
          })
          _selectPayFeeIds.push(feeItem.feeId)
        })

        this.batchPayFeeOrderInfo = {
          ...this.batchPayFeeOrderInfo,
          allBatchFees: _batchFees,
          selectPayFeeIds: _selectPayFeeIds,
          batchFees: _batchFees
        }

        this._pushPayObjs()
        this._doComputeTotalFee()

        // 设置表格选中状态
        this.setTableSelection()
      } catch (error) {
        console.error('请求失败:', error)
      } finally {
        this.loading = false
      }
    },

    _batchRoomFeeCompare(a, b) {
      if (a.payerObjName < b.payerObjName) return -1
      if (a.payerObjName > b.payerObjName) return 1
      return 0
    },

    _pushPayObjs() {
      const _allBatchFees = this.batchPayFeeOrderInfo.allBatchFees
      const _payObjs = []
      const _payerObjNames = []

      _allBatchFees.forEach(fee => {
        if (!fee.feeAttrs) return

        let _payerObjName = ''
        fee.feeAttrs.forEach(item => {
          if (item.specCd === '390012') {
            _payerObjName = item.value
          }
        })

        if (_payerObjName && !this._hasPayObjsIn(_payerObjName, _payObjs)) {
          _payObjs.push(_payerObjName)
          _payerObjNames.push(_payerObjName)
        }
      })

      this.batchPayFeeOrderInfo.payObjs = _payObjs
      this.batchPayFeeOrderInfo.payerObjNames = _payerObjNames
    },

    _hasPayObjsIn(payerObjName, payObjs) {
      return payObjs.includes(payerObjName)
    },

    _hasPayObjNamesIn(payerObjName) {
      return this.batchPayFeeOrderInfo.payerObjNames.includes(payerObjName)
    },

    _chanagePayerObjName() {
      const _allBatchFees = this.batchPayFeeOrderInfo.allBatchFees
      const _batchFees = []

      _allBatchFees.forEach(fee => {
        let _payerObjName = ''
        if (fee.feeAttrs) {
          fee.feeAttrs.forEach(item => {
            if (item.specCd === '390012') {
              _payerObjName = item.value
            }
          })
        }

        if (_payerObjName && this._hasPayObjNamesIn(_payerObjName)) {
          _batchFees.push(fee)
        }
      })

      this.batchPayFeeOrderInfo.batchFees = _batchFees

      // 更新 selectPayFeeIds，只保留当前显示的费用ID
      const currentFeeIds = _batchFees.map(fee => fee.feeId)
      this.batchPayFeeOrderInfo.selectPayFeeIds = this.batchPayFeeOrderInfo.selectPayFeeIds.filter(id =>
        currentFeeIds.includes(id)
      )

      this._doComputeTotalFee()

      // 重新设置表格选中状态
      this.setTableSelection()
    },

    _openPayFee(payType) {
      if (this.batchPayFeeOrderInfo.selectPayFeeIds.length <= 0) {
        this.$message.warning('未选择费用')
        return
      }

      const _payerObjName = this.batchPayFeeOrderInfo.payerObjNames.join(',')
      const params = {
        fees: this._getPayFees(),
        payType: payType,
        feePrices: this.batchPayFeeOrderInfo.feePrices,
        payerObjName: _payerObjName,
        acctId: this.batchPayFeeOrderInfo.acctId,
        accountAmount: this.batchPayFeeOrderInfo.accountAmount
      }

      this.$refs.batchPayConfirm.open(params)
    },

    _getPayFees() {
      const _selectPayFeeIds = this.batchPayFeeOrderInfo.selectPayFeeIds
      const _batchFees = this.batchPayFeeOrderInfo.batchFees
      const _fees = []

      _selectPayFeeIds.forEach(id => {
        _batchFees.forEach(fee => {
          if (id === fee.feeId) {
            _fees.push(fee)
          }
        })
      })

      return _fees
    },

    _goBack() {
      this.$router.go(-1)
    },

    _getDeadlineTime(fee) {
      if (fee.amountOwed === 0 && fee.endTime === fee.deadlineTime) return "-"
      if (fee.state === '2009001') return "-"
      return dateFormat(fee.deadlineTime)
    },

    _getEndTime(fee) {
      if (fee.state === '2009001') return "-"
      return dateFormat(fee.endTime)
    },

    _getBatchPayFeeRoomName(fee) {
      if (!fee.feeAttrs) return ""

      let _feeName = ''
      fee.feeAttrs.forEach(item => {
        if (item.specCd === '390012') {
          _feeName = item.value
        }
      })

      return _feeName
    },

    _getBatchPaymentCycles(fee) {
      const paymentCycles = []
      for (let i = 1; i < 13; i++) {
        paymentCycles.push(i * parseFloat(fee.paymentCycle))
      }
      return paymentCycles
    },

    _doComputeTotalFee() {
      const _selectPayFeeIds = this.batchPayFeeOrderInfo.selectPayFeeIds
      const _batchFees = this.batchPayFeeOrderInfo.batchFees
      const _accountAmount = this.batchPayFeeOrderInfo.accountAmount

      let _totalFee = 0

      _selectPayFeeIds.forEach(id => {
        _batchFees.forEach(fee => {
          if (id === fee.feeId && fee.receivedAmount) {
            _totalFee += parseFloat(fee.receivedAmount)
          }
        })
      })

      if (_accountAmount) {
        _totalFee = _totalFee - parseFloat(_accountAmount)
      }

      this.batchPayFeeOrderInfo.feePrices = Math.max(0, _totalFee).toFixed(2)
    },

    async _changeMonth(cycles, fee) {
      if (!cycles) {
        cycles = fee.cycles
      }

      if (fee.tempCycle === '-101') {
        this._doComputeTotalFee()
        return
      }

      try {
        const params = {
          communityId: this.communityId,
          feeId: fee.feeId,
          page: 1,
          row: 1,
          cycle: cycles
        }

        if (fee.tempCycle === '-103') {
          params.custEndTime = dateAdd(fee.custEndTime)
        }

        const res = await listFeeObj(params)
        if (res.code === 0) {
          fee.receivableAmount = res.data.feeTotalPrice
          fee.receivedAmount = fee.receivableAmount
          this._doComputeTotalFee()
        }
      } catch (error) {
        console.error('请求失败:', error)
      }
    },

    _settingsFeeCycle(batchFee) {
      this.$refs.batchFeeCycle.open(batchFee)
    },

    changeUserAmountPrice(data) {
      this.batchPayFeeOrderInfo.accountAmount = data.totalUserAmount;
      if (data.selectAccount && data.selectAccount.length > 0) {
        data.selectAccount.forEach(_acct => {
          if (_acct.acctType == '2003') {
            this.batchPayFeeOrderInfo.acctId = _acct.acctId;
          }
        })
      }
      this._doComputeTotalFee();
    },
    batchChangeMonth(fee) {
      this._changeMonth(fee.cycle, fee)
    },

    // 计算欠费时长（参考 simplifyRoomFee 组件）
    _calculateOweDuration(fee) {
      // 如果没有截止时间或已结清，返回-
      if (!fee.startTime || !fee.deadlineTime || fee.deadlineTime === '-') return '-'
      if (fee.state == '2009001') return '-'
      // 如果不欠费且结束时间等于截止时间，返回-
      if (fee.amountOwed == 0 && fee.endTime == fee.deadlineTime) return '-'
      
      // 使用 endTime(应收开始时间) 而不是 startTime(建账时间)
      const start = new Date(fee.endTime)
      const end = new Date(fee.deadlineTime)
      
      // 验证日期有效性
      if (isNaN(start.getTime()) || isNaN(end.getTime())) return '-'
      
      // 计算总天数差
      const diffTime = end - start
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      
      // 转换为年和月（按365天/年，30天/月近似计算）
      let years = Math.floor(diffDays / 365)
      let remainingDays = diffDays % 365
      let months = Math.floor(remainingDays / 30)
      
      // 如果月份>=12，进位到年
      if (months >= 12) {
        years += Math.floor(months / 12)
        months = months % 12
      }
      
      if (years <= 0 && months <= 0) return '不足1个月'
      if (years > 0 && months > 0) return `${years}年${months}个月`
      if (years > 0) return `${years}年`
      return `${months}个月`
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-pay-fee-order-container {
  padding: 20px;

  .payer-object-card {
    height: 100%;

    .card-title {
      padding: 10px;
      font-weight: bold;
    }

    .checkbox-list {
      padding: 10px;

      .checkbox-item {
        display: block;
        margin: 5px 0;
      }
    }
  }

  .footer-row {
    margin-top: 20px;
    padding: 20px;
    background: #f5f7fa;
    border-radius: 4px;

    .tips {
      color: #666;
      line-height: 1.6;
    }

    .total-amount {
      font-size: 16px;

      .amount {
        font-size: 30px;
        color: #f56c6c;
        margin-left: 5px;
      }
    }
  }

  .cycle-text,
  .custom-amount,
  .custom-end-time {
    line-height: 1.5;
    padding: 5px 0;
  }
}
</style>